import React from 'react';
import PropTypes from 'prop-types';
import {
  allowedLanguages,
  allowedFilterDataPropTypes,
  allowedTableColumnPropTypes
} from '../utils/allowedPropTypes';
import ColumnFilter from './_ColumnFilterController';

const DataTableHeading = (
  {
    columnData,
    languageCode,
    receivedAttributes = {},
    classNames = []
  }
) => {
  const {
    columnId,
    columnTitle,
    isGroupColumn,
    columnTextAlign,
    classNames: columnClassNames,
    dataFilter
  } = columnData;

  const attributes = Object.assign({ id: columnId }, receivedAttributes);
  let { columnHeadingContent: tableHeadingContent } = columnData;

  // Add special class names to group headings:
  if (isGroupColumn) {
    classNames.push('table-cell-group');
  }

  // Add special class names to aligned columns:
  if (columnTextAlign) {
    classNames.push(`column-align-${columnTextAlign}`);
  }

  // Add classnames if defined:
  if (columnClassNames) {
    classNames.push(...columnClassNames);
  }

  if (dataFilter) {
    classNames.push('table-heading-filter');

    const {
      filterData,
      filterOptions,
      renderOptionLabel
    } = dataFilter;

    tableHeadingContent = (
      <ColumnFilter
        filteredColumnId={columnId}
        filteredColumnTitle={columnTitle}
        languageCode={languageCode}
        placeholderContent={tableHeadingContent}
        filterOptions={filterOptions}
        renderOptionLabel={renderOptionLabel}
        filterData={filterData}
      />
    );
  }

  // Add class names to the attributes if there is any:
  if (classNames.length > 0) {
    const finalClassName = classNames.join(' ');
    const prevClassNames = attributes.className;
    attributes.className = (prevClassNames)
      ? `${prevClassNames} ${finalClassName}`
      : finalClassName;
  }

  return <th {...attributes}>{tableHeadingContent}</th>;
};

DataTableHeading.propTypes = {
  attributes: PropTypes.object,
  classNames: PropTypes.array,
  languageCode: PropTypes.oneOf(allowedLanguages),
  columnData: PropTypes.shape({
    ...allowedTableColumnPropTypes,
    columnTitle: PropTypes.string.isRequired
  }).isRequired,
  dataFilter: PropTypes.shape(allowedFilterDataPropTypes)
};

export default DataTableHeading;